import { SitesApi, ZonesApi } from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const sitesApi = new SitesApi(config);
export const zonesApi = new ZonesApi(config);

export const siteRequestInit = { credentials: 'include' as const };
